import { Component, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subject, Subscription } from 'rxjs';
import { Oil } from '../../../models/oil.model';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';
import { fadeInOut } from '../../../services/animations';
import { OilService } from '../../../services/oil.service';

@Component({
    selector: 'oil-overview',
    template: require('./oil-overview.component.html'),
    styles: [require('./oil-overview.component.css')],
    animations: [fadeInOut]
})
export class OilOverviewComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];

    loading: boolean;

    pagingData: Oil[] = [];
    currentPage = 1;
    pageSize = 20;
    search = '';
    totalRecords = 0;
    orderByField = 'Date';
    isDesc = false;
    modelChanged = new Subject<string>();
    constructor(private accountService: AccountService, private oilService: OilService, private ngxLogger: NGXLogger) { }
  ngOnInit() {
        const modelSub = this.modelChanged.debounceTime(500)
            .subscribe(() => {
                this.initializeDataListByPage(1);
            });
        this.subscribers.push(modelSub);
        this.initializeDataListByPage(1);
    }

    initializeDataListByPage(page: number) {
        this.loading = true;
        this.currentPage = page;
        const dataListByPageSub = this.oilService.getDataListByPage(page, this.pageSize, this.orderByField, this.isDesc, this.search)
            .subscribe((data: any) => {
                if (data && data.Item1) {
                    this.pagingData = data.Item1;
                    this.totalRecords = data.Item2;
                } else {
                    this.pagingData = [];
                    this.totalRecords = 0;
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.error(err);
                this.ngxLogger.error(err.message);
            });
        this.subscribers.push(dataListByPageSub);
    }

    globalSearch() {
        this.modelChanged.next();
    }

    paginate(event: any) {
        this.pageSize = event.rows;
        this.initializeDataListByPage(event.page + 1);
    }

    customSort(event: any) {
        let isDesc: boolean;
        if (event.order === -1) {
            isDesc = true;
        } else {
            isDesc = false;
        }
        if (event.field !== this.orderByField || isDesc !== this.isDesc) {
            this.orderByField = event.field;
            this.isDesc = isDesc;
            this.initializeDataListByPage(this.currentPage);
        }
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    get canoilOverviewPermission() {
        return this.accountService.userHasPermission(Permission.oilOverviewPermission);
    }

    get canoilExportPermission() {
        return this.accountService.userHasPermission(Permission.oilExportPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/oil/oil-overview/oil-overview.component.ts